<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row justify-center>
      <v-dialog v-model="dialogv" scrollable max-width="400px">
        <v-card v-if="!loading">
          <v-toolbar :color="partai.color" dark>
            <span class="display-1 mr-3">{{partai.no}}</span>
            <v-avatar size="60" class="elevation-5 mr-3" :color="partai.color">            
              <img :src="partai.thumb" v-if="partai.thumb"/>
              <span v-else class="white--text headline"></span>
            </v-avatar>             
            <span class="subheading">{{partai.akronim}}</span>
            <v-spacer></v-spacer>     
            <v-chip dark>{{quickcountMode ? (partai.hitung.quickcount ? partai.hitung.quickcount: 0):(partai.hitung.suara ? partai.hitung.suara: 0)}}</v-chip>
          </v-toolbar>                              
          <v-card-text style="height: 300px;" class="pa-0">            
            <v-container class="mt-2 pa-0">   
              <div class="ma-3">suara partai : {{quickcountMode ? (partai.single.quickcount ? partai.single.quickcount: 0):(partai.single.suara ? partai.single.suara:0)}}</div>
              <v-divider></v-divider>                                   
              <div class="v-table__overflow tabular">
                <v-data-table :headers="[  
                    {text:'No',value:'no',sortable:false,align:'center'},
                    {text:'Name',sortable:false,value:'name'},
                    {text:'Suara',value:'hitung.suara'}
                  ]"
                  :items="partai.child"  
                  :pagination.sync="pagination"
                  hide-actions
                  >
                  <template slot="items" slot-scope="props">                             
                    <tr>      
                      <td class="text-xs-center">{{props.item.no}}</td>                          
                      <td>                                
                          <v-list-tile-title v-html="props.item.name"></v-list-tile-title>                                 
                      </td>     
                      <td>
                        <span class="subheading">{{quickcountMode ? (props.item.hitung.quickcount ? props.item.hitung.quickcount: 0):(props.item.hitung.suara?props.item.hitung.suara:0)}}</span>                            
                      </td>
                    </tr>
                  </template>

                </v-data-table>
              </div>                                    
            </v-container>                                            
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="closeDialog">Close</v-btn>                            
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-toolbar>            
          </v-toolbar>                              
          <v-card-text style="height: 300px;" class="pa-0 pt-4 text-xs-center">    
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="closeDialog">Close</v-btn>                            
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>     
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/frc/models/Dashboard';   
const  model = new Model(); 
  
export default {  
  name: 'dialog-caleg',  
  props:{    
    cekup  : Object, 
    quickcountMode : {
      type: Boolean,
      default: false,
    },
    dialog : {
      type: Boolean,
      default: false,
    },
  },  
  asyncComputed : {
    init(){
      this.dialogv = this.dialog;
      if(this.dialogv){
        this.loading = true;
        model.calegs(this.cekup).then(resp=>{          
          Object.assign(this.partai, resp.data[0]?resp.data[0]:null);
          this.loading = false;
        });
      }
      return; 
    }    
  },
  data: () => ({  
    dialogv : false,
    partai:{},
    loading:true,
    pagination : {'sortBy': 'hitung.suara', 'descending': true, 'rowsPerPage': -1},
  }),  
  mounted(){ },
  created(){
     
  },
  watch: {
    dialogv(newVal){
      if(!newVal){
        this.closeDialog();
      }
    }
  },
  methods: {  
    closeDialog(){
      this.$emit('closeDialog',{dialog : false, cekup:{}});
    }
  }  
}
</script>
<style>
#sainte{border-collapse: collapse; width:100%}
#sainte th, #sainte td{border:1px solid #eee; padding:3px}
#sainte th{text-align: center}
</style>